const ButtonBaseOverrides = {
  defaultProps: {
    disableRipple: true,
  },
};

export default ButtonBaseOverrides;
